import { SimpleInput } from '@aloft/toolkit-sui';

import { Controller } from 'react-hook-form';

import { useZodFormContext } from '../../hooks/useZodForm.ts';

export function DefaultEcoLifeInput({ fieldPath, label }: { fieldPath: string; label?: string }) {
  const { control } = useZodFormContext();
  return (
    <Controller
      name={fieldPath}
      control={control}
      render={({ field }) => (
        <SimpleInput size="sm" type="number" precision={0} useSeparator label={label} {...field} />
      )}
    />
  );
}
